module.exports = __webpack_public_path__ + "img/firstwave.993f304f.png";